import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import { Button } from "@mui/material";
import { globalConfig } from "../../config/config";
import axios from 'axios';

export default class CreateVCSCheckoutObject extends Component {

	constructor(props)
	{
		console.log(props);
    	super(props);
  	}

  state = {
	    vcsCheckoutObjects : []
  	};

	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
		try {
		
//       axios.get(`${globalConfig.apiDatahubUrl}/vcs-checkout-objects/`,globalConfig.hardcoded_header).then(res => {
//       const vcsCheckoutObjects = res.data;
//       console.log(vcsCheckoutObjects);
//       this.setState({ vcsCheckoutObjects });
//       console.log(res.data[0]);
// 		});
		}catch(x){
		}	
	}
	
	render(){
    return (

	<form>
		<div class="container-fluid">
		<div style={{display: "flex", justifyContent: "space-between"}}>
			<h4>Check Out</h4>
			  <div>
			  <Link to="/waves">
			  	<Button variant="contained">Go Back</Button>
			  </Link>
			  </div>
		</div>
		<hr />
				<label class="ContentTitle col-sm-8" value="Checkout a Version for (File/Content Object Name/Alias) #{ombUserSession.currentContentObject._content_name }">
					Checkout a Version for (File/Content Object Name/Alias)
				</label>
			<hr />
				<div class="form-group row">
				<label  class="ContentTitle col-sm-2" value="Version Label" >Version Label</label>
				<select id="vcsLabelId"  class="form-control input-xlarge col-sm-8">
					<option value="#{ombVcsLabelForm.versionLabelList}" />
				</select>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Document Name">Document Name</label>
				<input class="form-control input-xlarge col-sm-8" id="documentName" 
					readonly="true" value="#{ombUserSession.currentContentObject._content_name }"
				 />
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Description" >Description</label>
				<input class="form-control input-xlarge col-sm-8" id="description"  />
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Current Disposition" >Current Disposition</label>
 	  	    	<select class="form-control input-xlarge col-sm-8" id="currentDisposition">
					<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ISSUE_DISPOSITION')}"/>
 	  			</select>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Current Disposition User">Current Disposition User</label>
				<select class="form-control input-xlarge col-sm-8" readonly="true" id="currentDispositionUserId">
		   	  				<option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" /> 
		   	  	</select>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Current Disposition Date(mm/dd/yyyy)">Current Disposition Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" id="currentDispositionTimestamp">
					
				</input>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Current Disposition Exp Date(mm/dd/yyyy)">Current Disposition Exp Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" id="currentDispositionExpTimestamp">
					
				</input>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Revision Number">Revision Number</label>
				<input class="form-control input-xlarge col-sm-8" id="revisionNumber" readonly="true" value="#{ombVcsObjectForm.getNextVersionForContentObject(ombUserSession.currentContentObject.get_content_id()) }"/>
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Lock">Lock</label>
				<input type="checkbox" id="lockFlag"/>
				</div>
				<div class="form-group row">
 				<label class="ContentTitle col-sm-2" value="Lock User">Lock User</label>
				<input class="form-control input-xlarge col-sm-8" readonly="true" id="lockUserId"					
				 />
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Lock Date(mm/dd/yyyy)">Lock Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" id="lockTimestamp" />
				</div>
			
			<hr/>
				<div class="form-group row">
 				<label class="ContentTitle col-sm-2" value="Last CheckIn User">Last CheckIn User</label>
				<input class="form-control input-xlarge col-sm-8" readonly="true" id="lastCheckInUserId" /> 
				</div>
				<div class="form-group row">
				<label class="ContentTitle col-sm-2" value="Last CheckIn Date(mm/dd/yyyy)">Last CheckIn Date(mm/dd/yyyy)</label>
				<input class="form-control input-xlarge date-picker col-sm-8" 					
					readonly="true" id="lastCheckInTimestamp" 
					 >
				</input>
				</div>
			<hr />
					<button value="Checkout" class="btn btn-success" action="#{ombVcsCheckedoutObjectForm.createCheckedOutVersion}" >
						Checkout
					</button>
			</div>	
	</form>
);
}
}

